var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isQuote)?_c('div',{class:{
    hero: true,
    'has-bg-img': true
  }},[_c('img',{staticClass:"image",attrs:{"src":_vm.isStatic
        ? `https://static.porscheautoinsurance.com/images/${_vm.image}.${_vm.extension}`
        : require(`@/assets/img/homepage/${_vm.image}.${_vm.extension}`),"alt":"Hero-Image"}}),_c('img',{staticClass:"hero-image-mobile",attrs:{"src":_vm.isStatic
        ? `https://static.porscheautoinsurance.com/images/${_vm.image}.${_vm.extension}`
        : require(`@/assets/img/homepage/Mobile_${_vm.image}.${_vm.extension}`),"alt":"Hero-Image-Mobile"}}),_c('div',{staticClass:"body"},[_c('div',{staticClass:"container title-container"},[_c('p',{class:{
          title: true,
          'mobile-font-size': true,
          'is-sr-only': _vm.title_sr_only
        },domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{class:{
          title: true,
          subtitle: true,
          'mobile-font-size': true,
          'is-sr-only': _vm.title_sr_only
        },domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])])]):_c('div',{class:{
    hero: true,
    'has-bg-img': true
  }},[_c('img',{staticClass:"image",attrs:{"src":require(`@/assets/img/${_vm.image}.${_vm.extension}`),"alt":"Hero-Image"}}),_c('img',{staticClass:"hero-image-mobile",attrs:{"src":require(`@/assets/img/${_vm.image}-Mobile.${_vm.extension}`),"alt":"Hero-Image-Mobile"}}),_c('div',{staticClass:"body"},[_c('div',{staticClass:"container"},[_c('p',{class:{
          title: true,
          'mobile-font-size': true,
          'is-sr-only': _vm.title_sr_only
        },domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{class:{
          title: true,
          subtitle: true,
          'mobile-font-size': true,
          'is-sr-only': _vm.title_sr_only
        },domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }